import TableRowStatusBadge from '@/src/components/molecule/TableRowStatusBadge';
import {
  ColSize,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createNumberCol,
  createStatusBadgeCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import { ColDef, ValueGetterParams } from 'ag-grid-community';

export const recyclingPackageProductListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createTypoCol({
    field: 'name',
    size: 'lg',
    headerName: '수거 품목명',
  }),
  createNumberCol({
    field: 'weight',
    size: 'sm',
    headerName: '무게 (g)',
  }),
  createNumberCol({
    field: 'carbonEmissionReduction',
    size: 'sm',
    headerName: '탄소 감축량 (g)',
  }),
  createNumberCol({
    field: 'pineScore',
    size: 'sm',
    headerName: '소나무 지수',
  }),
  createTypoCol({
    field: 'unitKr',
    size: 'sm',
    headerName: '단위',
  }),
  createNumberCol({
    field: 'maximumWeight',
    size: 'sm',
    headerName: '최대 무게',
  }),
  createStatusBadgeCol({
    field: 'isForApp',
    type: 'isApplied',
    headerName: '앱 적용 여부',
    size: 'sm',
  }),
  createDetailButtonColV2(onDetailClick),
];
